import * as actionTypes from '../actionTypes';
import axios from "../../../axios";
import { getAxiosHeader } from "../../../shared/utility";

export const fetchCoursesStart = () => {
  return {
    type: actionTypes.FETCH_COURSES_START
  };
};
export const fetchCoursesSuccess = (courses) => {
  return {
    type: actionTypes.FETCH_COURSES_SUCCESS,
    courses: courses
  }
};
export const fetchCoursesFail = (error) => {
  return {
    type: actionTypes.FETCH_COURSES_FAIL,
    error: error
  }
};
export const fetchCourses = () => {
  return dispatch => {
    dispatch(fetchCoursesStart());

    const headers = getAxiosHeader();
    axios.get('/courses', headers)
      .then(res => {
        //console.log('fetchCourses res', res.data.data);
        dispatch(fetchCoursesSuccess(res.data.data));
      })
      .catch(err => {
        //console.log('fetchCourses error', err);
        dispatch(fetchCoursesFail(err));
      });
  }
};

export const fetchSingleCourseStart = () => {
  return {
    type: actionTypes.FETCH_SINGLE_COURSE_START
  };
};
export const fetchSingleCourseSuccess = (course) => {
  return {
    type: actionTypes.FETCH_SINGLE_COURSE_SUCCESS,
    course: course
  }
};
export const fetchSingleCourseFail = (error) => {
  return {
    type: actionTypes.FETCH_SINGLE_COURSE_FAIL,
    error: error
  }
};
export const fetchSingleCourse = (slug) => {
  return dispatch => {
    dispatch(fetchSingleCourseStart());
    const headers = getAxiosHeader();
    axios.get('/courses/' + slug, headers)
      .then(res => {
        //console.log('fetchCourses', res.data.data);
        dispatch(fetchSingleCourseSuccess(res.data.data));
      })
      .catch(err => {
        //console.log(err);
        dispatch(fetchSingleCourseFail(err));
      });
  }
};
export const fetchSingleCourseUnmount = () => {
  return {
    type: actionTypes.FETCH_SINGLE_COURSE_UNMOUNT
  };
};

/***************************
COURSE ACCESS
**************************/
export const fetchCourseAccessStart = () => {
  return {
    type: actionTypes.FETCH_COURSE_ACCESS_START
  };
};
export const fetchCourseAccessSuccess = (courseAccess) => {
  return {
    type: actionTypes.FETCH_COURSE_ACCESS_SUCCESS,
    courseAccess: courseAccess
  }
};
export const fetchCourseAccessFail = (error) => {
  return {
    type: actionTypes.FETCH_COURSE_ACCESS_FAIL,
    error: error
  }
};
export const fetchCourseAccess = (slug) => {
  return dispatch => {
    dispatch(fetchCourseAccessStart());
    const headers = getAxiosHeader();
    axios.get('/courses/' + slug + '/access', headers)
      .then(res => {
        //console.log('fetchCourseAccessSuccess', res.data.data);
        dispatch(fetchCourseAccessSuccess(res.data.data));
      })
      .catch(err => {
        //console.log(err);
        dispatch(fetchCourseAccessFail(err));
      });
  }
};
export const fetchCourseAccessUnmount = () => {
  return {
    type: actionTypes.FETCH_COURSE_ACCESS_UNMOUNT
  };
};
/*************************************/

export const jumpToLesson = () => {
  return {
    type: actionTypes.JUMP_TO_LESSON
  }
}
export const jumpToLessonRevert = () => {
  return {
    type: actionTypes.JUMP_TO_LESSON_REVERT
  }
}


export const fetchCourseModulesStart = () => {
  return {
    type: actionTypes.FETCH_COURSE_MODULES_START
  };
};
export const fetchCourseModulesSuccess = (courseModules) => {
  return {
    type: actionTypes.FETCH_COURSE_MODULES_SUCCESS,
    courseModules: courseModules
  }
};
export const fetchCourseModulesFail = (error) => {
  return {
    type: actionTypes.FETCH_COURSE_MODULES_FAIL,
    error: error
  }
};
export const fetchCourseModules = (slug) => {
  return dispatch => {
    dispatch(fetchCourseModulesStart());
    const headers = getAxiosHeader();
    axios.get('/courses/' + slug + '/modules', headers)
      .then(res => {
        //console.log('fetchCourseModules', res.data.data);
        dispatch(fetchCourseModulesSuccess(res.data.data));
      })
      .catch(err => {
        //console.log('fetchCourseModules error', err);
        dispatch(fetchCourseModulesFail(err));
      });
  }
};
export const fetchCourseModulesUnmount = () => {
  return {
    type: actionTypes.FETCH_COURSE_MODULES_UNMOUNT
  };
};